import banner from "../../static/img/app-banner.png";
import appStoreBadge from "../../static/img/app-store-badge.png";
import googlePlayBadge from "../../static/img/google-play-badge.jpg";
import RecentCleanupsFeed from "../../components/RecentCleanupsFeed";
import Footer from "../../components/Footer";

export default function LandingScreen() {
  return (
    <div className="App" style={{ marginBottom: 100 }}>
      <img src={banner} className="banner" alt="banner" width="100%"></img>
      <div style={{ paddingBottom: 50 }}>
        <a href="https://apps.apple.com/us/app/808-cleanups/id1464605740">
          <img
            src={appStoreBadge}
            style={{ margin: 10 }}
            alt="appStore"
            width="25%"
          ></img>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.app808cleanups&hl=en_US">
          <img
            src={googlePlayBadge}
            style={{ margin: 10 }}
            alt="playStore"
            width="25%"
          ></img>
        </a>
      </div>

      {/* Recent Cleanups Feed */}
      <RecentCleanupsFeed />

      {/* Footer */}
      <Footer />
    </div>
  );
}
